import { render, staticRenderFns } from "./appNotifications.vue?vue&type=template&id=5bf25480&scoped=true"
import script from "./appNotifications.vue?vue&type=script&lang=js"
export * from "./appNotifications.vue?vue&type=script&lang=js"
import style0 from "./appNotifications.vue?vue&type=style&index=0&id=5bf25480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf25480",
  null
  
)

export default component.exports